import { Button, Flex, Typography } from 'antd';
import { useState } from 'react';
import { Link } from 'react-router-dom';

import IconPaste from '@/assets/icons/paste.svg?react';
import { FetchingDataLoading, PageTitle } from '@/components';
import { ROUTES_PATH } from '@/constants/routes.constants';
import { OrganizationFilters } from '@/features/organization/components/organization-filters';
import { OrganizationTable } from '@/features/organization/components/tables/organization-table';
import { useDeleteOrganization } from '@/features/organization/mutations/organization';
import {
  useFetchOrganizationsOfMe,
  useOrganizations,
} from '@/features/organization/queries/organization';
import { useUserInformation } from '@/hooks/use-user-information';
import { useCommonStore } from '@/store/common.store';

const { Text } = Typography;

export function OrganizationList() {
  useFetchOrganizationsOfMe();
  const { isSbfMasterRole } = useUserInformation();
  const [currentPage, setCurrentPage] = useState(1);
  const [filtersValues, setFiltersValues] = useState({});
  const scrollTop = useCommonStore(state => state.scrollTop);

  const { data, isLoading, isFetching, refetch } = useOrganizations({
    page: currentPage,
    ...filtersValues,
  });

  const { mutate: deleteOrganization } = useDeleteOrganization({
    onSuccess: () => refetch(),
  });

  function handlePageChange(page: number) {
    scrollTop?.();
    setCurrentPage(page);
  }

  function handleSearch() {
    scrollTop?.();
    setCurrentPage(1);
  }

  if (isLoading) return <FetchingDataLoading />;

  return (
    <>
      <PageTitle
        title="チェーン"
        rightContent={
          <Flex align="center">
            {isSbfMasterRole && (
              <Link
                className="mr-12 place-items-center"
                to={ROUTES_PATH.organizationAcodeUpdate}
              >
                <IconPaste width={14} height={14} />
                <Text underline className="text-sm ml-4">
                  請求情報の更新
                </Text>
              </Link>
            )}
            <Link to={ROUTES_PATH.organizationNew}>
              <Button type="primary">新規登録</Button>
            </Link>
          </Flex>
        }
      />
      <OrganizationFilters
        filtersValues={filtersValues}
        onReset={handleSearch}
        onFinish={handleSearch}
        setFilterValues={setFiltersValues}
      />
      <OrganizationTable
        loading={isFetching}
        dataSource={data?.organizations}
        deleteOrganization={deleteOrganization}
        pagination={{
          current: currentPage,
          total: data?.total_records,
          onChange: handlePageChange,
        }}
      />
    </>
  );
}
